import { render } from "./createItem.vue?vue&type=template&id=64889670&scoped=true"
import script from "./createItem.vue?vue&type=script&lang=js"
export * from "./createItem.vue?vue&type=script&lang=js"

import "./createItem.vue?vue&type=style&index=0&id=64889670&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64889670"]])

export default __exports__